import React, { ErrorInfo } from "react";
import ReactGA from "react-ga4";
import { Button } from "theme";

import { InvertButton } from "../../theme/components/Button/Button.tsx";

import "./ErrorBoundary.css";

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("Error caught by ErrorBoundary:", error);
    console.error("Component stack:", errorInfo.componentStack);
  }

  resetErrorBoundary = (): void => {
    this.setState({
      hasError: false,
      error: null,
    });
    localStorage.clear();
  };

  render(): React.ReactNode {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      ReactGA.event({
        category: "error",
        action: "error_boundary",
      });
      return (
        <div className="error-page">
          <div className="error-container">
            <div className="error-icon-container">
              <div className="error-icon"></div>
            </div>
            <div className="error-content">
              <span className="error-badge">Помилка</span>
              <h1 className="error-title">Щось пішло не так.</h1>
              <p className="error-message">Просимо вибачення за незручності.</p>
              <div className="error-actions">
                <Button onClick={this.resetErrorBoundary}>Перезавантажити</Button>
                <InvertButton
                  onClick={() => {
                    localStorage.clear();
                    window.location.href = "/";
                  }}
                >
                  На головну
                </InvertButton>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
